import React from "react";
import { Helmet } from "react-helmet-async";
import { Link } from "react-router-dom";
import { MarketingShell } from "../components/MarketingShell";
import { getPublicSiteOrigin } from "../api/client";

export default function BlogPage() {
  const origin = getPublicSiteOrigin() || "https://setpilot.org";
  const url = `${origin}/blog`;
  const title = "SetPilot blog — DJ sets, harmonic mixing & product updates";
  const description =
    "Articles on harmonic mixing, DJ set planning, and SetPilot updates. New posts coming soon.";

  return (
    <MarketingShell>
      <Helmet>
        <title>{title}</title>
        <meta name="description" content={description} />
        <link rel="canonical" href={url} />
        <meta property="og:title" content={title} />
        <meta property="og:description" content={description} />
        <meta property="og:url" content={url} />
        <meta property="og:type" content="website" />
        <meta name="twitter:card" content="summary_large_image" />
        <meta name="twitter:title" content={title} />
        <meta name="twitter:description" content={description} />
      </Helmet>

      <article className="m-prose">
        <h1>Blog</h1>
        <p className="m-lede">
          We&apos;re preparing short posts on <strong>harmonic mixing</strong>, set structure, and product updates. Check
          back soon, or <Link to="/">open the app</Link> to build a set today.
        </p>
        <p style={{ color: "var(--muted)", fontSize: 14 }}>— The SetPilot team</p>
        <p style={{ marginTop: 28 }}>
          <Link to="/">← Back to the app</Link>
        </p>
      </article>
    </MarketingShell>
  );
}
